import React from 'react';
import '../css/OpenAssignedProfileModal.css';

const OpenAssignedProfileModal = ({ profiles, onSelect, onClose }) => {
  const items = Array.isArray(profiles) ? profiles : [];

  return (
    <div className="open-profile-modal-overlay" role="presentation" onMouseDown={onClose}>
      <section
        className="open-profile-modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="open-profile-modal-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="open-profile-modal-header">
          <div>
            <h2 id="open-profile-modal-title" className="open-profile-modal-title">
              Open EMS profile?
            </h2>
            <p className="open-profile-modal-subtitle">
              {items.length} participants added. Select one to open.
            </p>
          </div>
          <button type="button" className="open-profile-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>

        <div className="open-profile-modal-body">
          <ul className="open-profile-modal-list">
            {items.map((profile) => (
              <li key={String(profile.participantId)}>
                <button
                  type="button"
                  className="open-profile-modal-list-btn"
                  onClick={() => onSelect(profile.participantId)}
                >
                  <span className="open-profile-modal-list-name">
                    {profile.name || 'Unnamed participant'}
                  </span>
                  <span className="open-profile-modal-list-chevron" aria-hidden="true">
                    ›
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>

        <footer className="open-profile-modal-footer">
          <button type="button" className="open-profile-modal-dismiss" onClick={onClose}>
            Not now
          </button>
        </footer>
      </section>
    </div>
  );
};

export default OpenAssignedProfileModal;
